export const WELCOME_STORAGE_KEY = 'shinai:welcome:v1'

let acknowledgedInRuntime = false

function browserStorage(name) {
    if (typeof window === 'undefined') return null
    try {
        return window[name]
    } catch (_) {
        return null
    }
}

function hasAcknowledgement(storage) {
    if (!storage) return false
    try {
        return storage.getItem(WELCOME_STORAGE_KEY) === 'seen'
    } catch (_) {
        return false
    }
}

function storeAcknowledgement(storage) {
    if (!storage) return false
    try {
        storage.setItem(WELCOME_STORAGE_KEY, 'seen')
        return true
    } catch (_) {
        return false
    }
}

export function shouldShowWelcome(
    storage = browserStorage('localStorage'),
    sessionStorage = browserStorage('sessionStorage')
) {
    if (acknowledgedInRuntime) return false
    const acknowledged = hasAcknowledgement(storage) || hasAcknowledgement(sessionStorage)
    if (acknowledged) acknowledgedInRuntime = true
    return !acknowledged
}

export function rememberWelcome(
    storage = browserStorage('localStorage'),
    sessionStorage = browserStorage('sessionStorage')
) {
    acknowledgedInRuntime = true
    const persisted = storeAcknowledgement(storage)
    const persistedForTab = storeAcknowledgement(sessionStorage)
    return persisted || persistedForTab
}
